import { userConstants } from '../redux-constants'
import { googleProvider, facebookProvider } from '../firebase'

export function signIn(email, password) {
    return (dispatch, getState, { firestore, firebase }) => {
        dispatch(ajaxCallProgress())
        firebase
            .auth()
            .signInWithEmailAndPassword(email, password)
            .then(result => {
                //firebase.analytics().logEvent('login', { email: email })
                dispatch(ajaxCallSuccess())
            })
            .catch(error => {
                dispatch(ajaxCallFailure(error.code))
            })
    }
}

export function enterWithFacebook(profile) {
    return (dispatch, getState, { firestore, firebase }) => {
        dispatch(ajaxCallProgress())

        firebase
            .auth()
            .signInWithPopup(facebookProvider)
            .then(response => {
                console.log(response)
                if (response.additionalUserInfo?.isNewUser) {
                    const userProfile = {
                        ...profile,
                        ...{
                            email: response.additionalUserInfo?.profile?.email,
                            name:
                                response.additionalUserInfo?.profile
                                    ?.first_name,
                            surname:
                                response.additionalUserInfo?.profile?.last_name,
                        },
                    }

                    firestore
                        .collection('users')
                        .doc(response.user.uid)
                        .set(userProfile)
                        .then(() => {
                            dispatch(ajaxCallSuccess())
                        })
                        .catch(error => {
                            dispatch(ajaxCallFailure(error.code))
                        })
                } else {
                    dispatch(ajaxCallSuccess())
                }
            })
            .catch(error => {
                dispatch(ajaxCallFailure(error.code))
            })
    }
}

export function enterWithGoogle(profile) {
    return (dispatch, getState, { firestore, firebase }) => {
        dispatch(ajaxCallProgress())

        firebase
            .auth()
            .signInWithPopup(googleProvider)
            .then(response => {
                if (response.additionalUserInfo?.isNewUser) {
                    const userProfile = {
                        ...profile,
                        ...{
                            email: response.additionalUserInfo?.profile?.email,
                            name:
                                response.additionalUserInfo?.profile
                                    ?.given_name,
                            surname:
                                response.additionalUserInfo?.profile
                                    ?.family_name,
                        },
                    }

                    firestore
                        .collection('users')
                        .doc(response.user.uid)
                        .set(userProfile)
                        .then(() => {
                            dispatch(ajaxCallSuccess())
                        })
                        .catch(error => {
                            dispatch(ajaxCallFailure(error.code))
                        })
                }

                dispatch(ajaxCallSuccess())
            })
            .catch(error => {
                dispatch(ajaxCallFailure(error.code))
            })
    }
}

export function signUp(email, password, profile) {
    return (dispatch, getState, { firestore, firebase }) => {
        dispatch(ajaxCallProgress())

        firebase
            .auth()
            .createUserWithEmailAndPassword(email, password)
            .then(response => {
                firestore
                    .collection('users')
                    .doc(response.user.uid)
                    .set(profile)
                    .then(val => {
                        response.user
                            .sendEmailVerification()
                            .then(() => {
                                console.log('email sent')
                                dispatch(ajaxCallSuccess())
                            })
                            .catch(error => {
                                dispatch(ajaxCallFailure(error.code))
                            })
                    })
                    .catch(error => {
                        dispatch(ajaxCallFailure(error.code))
                    })
            })
            .catch(error => {
                dispatch(ajaxCallFailure(error.code))
            })
    }
}

export function verifySignUpEmail(code) {
    return (dispatch, getState, { firestore, firebase }) => {
        dispatch(ajaxCallProgress())

        firebase
            .auth()
            .applyActionCode(code)
            .then(resp => {
                dispatch(verifyEmailSuccess())
            })
            .catch(error => {
                dispatch(ajaxCallFailure(error.code))
            })
    }
}

export function signOut() {
    return (dispatch, getState, { firestore, firebase }) => {
        dispatch(signOutProgress())
        firebase
            .auth()
            .signOut()
            .then(response => {
                dispatch(signOutSuccess())
            })
            .catch(error => {
                dispatch(ajaxCallFailure(error.code))
            })
    }
}

export function updateProfile(id, payload) {
    return (dispatch, getState, { firestore, firebase }) => {
        dispatch(ajaxCallProgress())
        const field = firestore.collection('/users').doc(id)
        console.log('payload', payload)
        field
            .update(payload)
            .then(res => {
                //firebase.analytics().logEvent('edit_profile', { id: id })
                dispatch(ajaxCallSuccess())
            })
            .catch(error => {
                console.log(error)
                dispatch(ajaxCallFailure(error.code))
            })
    }
}

export function resetPassword(email) {
    return (dispatch, getState, { firestore, firebase }) => {
        dispatch(ajaxCallProgress())

        firebase
            .auth()
            .sendPasswordResetEmail(email)
            .then(() => {
                dispatch(ajaxCallSuccess())
            })
            .catch(error => {
                dispatch(ajaxCallFailure(error.code))
            })
    }
}

export function ajaxCallProgress() {
    return {
        type: userConstants.AJAX_CALL_REQUEST,
    }
}

export function ajaxCallSuccess(notificationText) {
    return {
        type: userConstants.AJAX_CALL_SUCCESS,
        notificationText,
    }
}

function ajaxCallFailure(payload) {
    return {
        type: userConstants.AJAX_CALL_FAILURE,
        payload,
    }
}

export function checkUserAuthDone() {
    return {
        type: userConstants.CHECK_USER_AUTH_DONE,
    }
}

function signOutSuccess() {
    return {
        type: userConstants.LOGOUT_SUCCESS,
    }
}

function signOutProgress() {
    return {
        type: userConstants.LOGOUT_REQUEST,
    }
}

function verifyEmailSuccess() {
    return {
        type: userConstants.VERIFY_EMAIL_SUCCESS,
    }
}
